// extracted by mini-css-extract-plugin
export default {"wrapper":"dostavka_wrapper__t47vW","block":"dostavka_block__Xf3aI","left":"dostavka_left__JrCv7","svg":"dostavka_svg__0zNHQ","hr":"dostavka_hr__cq7B3"};